import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=6f2dd7f0&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AdminLayout.vue?vue&type=style&index=1&id=6f2dd7f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2dd7f0",
  null
  
)

export default component.exports